import Carousel from 'components/carousel/Carousel';
import React from 'react';
import { HotelTopPicksType } from 'types/types';
import styles from './TopPicksCarousel.module.scss';
import TopPickCard from 'blocks/TopPickCard/TopPickCard';
interface TopPicksCarouselProps {
  ourHotels: HotelTopPicksType[];
}

const TopPicksCarousel: React.FC<TopPicksCarouselProps> = ({ ourHotels }) => {
  return (
    <Carousel
      customStyles={styles}
      options={{
        loop: true,
        showNumber: true,
      }}
    >
      {ourHotels.map(hotel => (
        <TopPickCard key={hotel.id} hotel={hotel} />
      ))}
    </Carousel>
  );
};

export default TopPicksCarousel;
